import { actions, getTagsLookupsAsync, createTagAsync } from './slices';

export const TagsActions = {
  ...actions,
  getTagsLookupsAsync,
  createTagAsync,
};
